import Flow from './page-types/flow'

import MainHeader from './headers/main'

// main views
import AddressChooser from './address-chooser'
import ContextViewer from './context-viewer'
import CookieConsent from './cookie-consent'
import Dashboard from './dashboard'
import ExternalUserLogin from './external-user-login'
import GoAhead from './go-ahead'
import LogIn from './login'
import Message from './message'
import MyAccount from './my-account'
import MyHome from './my-home'
import MyHomeEdit from './my-home-edit'
import PlanChooser from './plan-chooser'
import PlanBuilder from './plan-builder'
import PlanServices from './plan-services'
import PlanSummaryReview from './plan-summary-review'
import PlanNotesForm from './plan-notes'
import PolicyWrapper from './policy-wrapper'
import ReCaptcha from './recaptcha'
import Registration from './registration'
import ResetPassword from './reset-password'
import Search from './search'
import Welcome from './welcome'

// service basket views
import BasketSummary from './service-basket/basket-summary'
import FinancialServices from './service-basket/financial-services'
import HomeEnergyPlan from './service-basket/home-energy-plan'

// test components
import Components from './test/components'

export default {
    AddressChooser,
    ContextViewer,
    CookieConsent,
    GoAhead,
    LogIn,
    Message,
    User: {
        MyAccount,
        Dashboard,
    },
    MyHome: {
        Summary: MyHome,
        Edit: MyHomeEdit,
    },
    Plan: {
        Builder: PlanBuilder,
        Chooser: PlanChooser,
        NotesForm: PlanNotesForm,
        Services: PlanServices,
        SummaryReview: PlanSummaryReview,
    },
    PolicyWrapper,
    ReCaptcha,
    Registration,
    ResetPassword,
    ServiceBasket: {
        BasketSummary,
        FinancialServices,
        HomeEnergyPlan,
    },
    Welcome,
    Search,
    Pages: {
        Flow,
    },
    Headers: {
        Main: MainHeader,
    },
    Test: {
        Components,
    },
    ExternalUserLogin,
}
